import { render } from "./pie.vue?vue&type=template&id=16252e3b&scoped=true"
import script from "./pie.vue?vue&type=script&lang=js"
export * from "./pie.vue?vue&type=script&lang=js"

import "./pie.vue?vue&type=style&index=0&id=16252e3b&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src384613071/src/admin-ui-svc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16252e3b"]])

export default __exports__